<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div class="my">
  <ng-container *ngFor="let attachment of attachments">
    <button pButton
            class="file-button flex-column"
            icon="ui-icon-insert-drive-file"
            (click)="download(attachment.fileStoreAttachmentUuid)"
            [label]="attachment.fileName" data-testid="attachment-file-name-btn"></button>
  </ng-container>
</div>


